import { i18n } from '@/plugins/i18n'

export const itemStatus = {
    PENDING:    true,
    PUBLISHED:  false,
};

export const itemStatusStr = {
    PENDING:    i18n.t('online-factor.archive') ,
    PUBLISHED:  i18n.t('online-factor.active') ,

    get(status) {
        let status_str = null;

        Object.keys(itemStatus).forEach(item => {
            if(itemStatus[item] === status) {
                status_str = itemStatusStr[item];
            }
        });

        return status_str;
    }
};

export const itemStatusVariant = (status) => {
    if(status === itemStatus.PUBLISHED) {
        return 'success';
    }

    if(status === itemStatus.PENDING) {
        return 'warning';
    }

    return 'secondary';
};
